const transformDataAttrsDictToProps = (dataAttrs = {}, props = {}) => {
  const _props = {};
  Object.keys(dataAttrs).forEach(attrName => {
    _props[`data-${attrName}`] = dataAttrs[attrName];
  });
  Object.keys(props).forEach(attrName => {
    if (attrName.slice(0, 5) === "data-") {
      _props[attrName] = props[attrName];
    }
  });
  return _props;
};

export { transformDataAttrsDictToProps };